import React, { useState } from 'react';

import Modal from 'components/new_ui/Modal/Modal';

import useEnterprises from 'components/Common/Users/Hooks/useEnterprises';

import { Button } from 'react-bootstrap5';

import confirmAlert from 'components/new_ui/Alerts/confirm';

import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Actions from './Actions';

export default function Index() {
  const [show, setShow] = useState(false);

  const enterprises = useEnterprises();

  const onClose = () => setShow(false);
  const onOpen = () => setShow(true);

  const formSchema = Yup.object().shape({
    enterprise: Yup.string().nullable().required('Enterprise is required'),
  });

  const onSubmit = (values, { setSubmitting }) => {
    setSubmitting(false);
    const enterprise = enterprises.find((e) => e.id === values.enterprise);
    confirmAlert({
      title: 'Confirm Selection',
      text: `Switch to ${enterprise.attributes.name}?`,
      confirmButtonText: 'Confirm',
    }, () => {
      setSubmitting(true);
      Actions.switch(values.enterprise, () => window.location.reload());
    });
  };

  return (
    <>
      {enterprises && enterprises.length > 0 && (
        <>
          <Button onClick={onOpen}>Select Enterprise</Button>
          <Modal onHide={onClose} show={show} size="lg" header={<h2 className="ms-3">Enterprises</h2>}>
            <p>Choose an organization to view its dashboard.</p>
            <Formik
              validationSchema={formSchema}
              initialValues={{
                enterprise: null,
              }}
              onSubmit={onSubmit}
            >
              {({ isSubmitting }) => (
                <FormikForm className="needs-validation" noValidate="">
                  <HorizontalSelectField
                    name="enterprise"
                    label="Enterprise"
                    placeholder="Select Enterprise"
                    options={enterprises.map((enterprise) => ({
                      label: enterprise.attributes.name,
                      value: enterprise.id,
                    }))}
                    required
                  />

                  <footer>
                    <Button
                      variant="outline-primary"
                      disabled={isSubmitting}
                      onClick={() => onClose()}
                    >
                      Cancel
                    </Button>

                    <Button
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting && (
                      <LoadingPlaceholder placement="inline" text=" " />
                      )}
                      Switch
                    </Button>
                  </footer>
                </FormikForm>
              )}
            </Formik>
          </Modal>
        </>
      )}
    </>
  );
}
